import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Button,
  Typography,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { extractErrorMessage } from 'utils/extractErrorMessage';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import SystemDashboard from 'layouts/SystemDashboard';
import Container from 'components/Container';
import { Orders, SummaryBox } from './components';
import { getCartItems } from '../../../../views/Ecommerce/Cart/CartService';

const Cart = (): JSX.Element => {
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem('token')); // Example check for login status

  useEffect(() => {
    if (isLoggedIn) {
      getCartItems()
        .then((response) => setCartItems(response.data))
        .catch((err) => setErrorMessage(extractErrorMessage(err)));
    } else {
      const localCart = JSON.parse(localStorage.getItem('cart') || '[]');
      setCartItems(localCart);
    }
  }, [isLoggedIn]);

  const handleCheckout = () => {
    if (!isLoggedIn) {
      navigate('/login'); // Redirect to login
    } else {
      navigate('/ecommerce/checkout'); // Proceed to checkout
    }
  };

  return (
    <Container>
      <SystemDashboard>
        {errorMessage && (
          <Alert
            severity="error"
            onClose={() => setErrorMessage('')}
            sx={{ mb: 2 }}
          >
            {errorMessage}
          </Alert>
        )}
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System
            </Link>
            <Typography color="text.primary">Shopping cart</Typography>
          </Breadcrumbs>
        </Box>
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
              <Typography variant="h6" fontWeight={700} marginBottom={4}>
                Shopping cart
              </Typography>
              <Orders cartItems={cartItems} setCartItems={setCartItems} />
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                elevation={0}
                sx={{
                  bgcolor: 'alternate.main',
                  padding: { xs: 2, sm: 4 },
                }}
              >
                <Typography variant="h6" fontWeight={700} marginBottom={4}>
                  Order summary
                </Typography>
                <SummaryBox cartItems={cartItems} />
                <Button
                  variant="contained"
                  fullWidth
                  sx={{ marginTop: 4 }}
                  onClick={handleCheckout}
                >
                  Checkout
                </Button>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default Cart;
